var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59226 29.9426C2.77083 29.9426 2.06738 29.6499 1.48192 29.0644C0.896463 28.4789 0.604231 27.776 0.605227 26.9556V6.04633H3.59226V26.9556H20.0209V29.9426H3.59226ZM9.56632 23.9685C8.74489 23.9685 8.04144 23.6758 7.45599 23.0903C6.87053 22.5049 6.5783 21.8019 6.57929 20.9815V3.0593C6.57929 2.23787 6.87202 1.53442 7.45748 0.948962C8.04294 0.363504 8.74589 0.0712725 9.56632 0.0722682H23.008C23.8294 0.0722682 24.5329 0.364997 25.1183 0.950456C25.7038 1.53591 25.996 2.23886 25.995 3.0593V20.9815C25.995 21.8029 25.7023 22.5064 25.1168 23.0918C24.5314 23.6773 23.8284 23.9695 23.008 23.9685H9.56632Z",
    fill: "#A0A8B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.713a35af06f9e808749cfc4a80f3618f.svg";
export { ForwardRef as ReactComponent };